import React, { Fragment, useContext, useEffect, useState } from "react";
import CardList from "./CardList";
import ReceiptIframe from "../Nftf/Receipt/ReceiptIframe";
import { NativeAction } from "../../modules/utils/HandleWs";
import { PostApi1972 } from "../../modules/network/padoPost";
import { AppContext } from "../../components/AppProvider";
import ToastMsg, {
  toastMsgObj,
} from "../../components/UI/Layer/ToastMsg/ToastMsg";
import { IC } from "../../resources/Assets";

const Card = () => {
  //pageType = list, add, mod
  const { userinfo, cfg, phonecfg } = useContext(AppContext);
  const [pageType, setPageType] = useState("list");
  const [moveUrl, setMoveUrl] = useState();

  // 등록된 카드목록
  const [cardList, setCardList] = useState();
  const [loading, setLoading] = useState(false);

  const getMyCardList = () => {
    PostApi1972(userinfo, cfg, phonecfg)
      .then(res => {
        if (res.result.length > 0) {
          let activeCardList = new Array();
          let errCardList = new Array();

          for (let i = 0; i < res.result.length; i++) {
            if (res.result[i].errChkYn === "N") {
              activeCardList.push(res.result[i]);
            } else {
              errCardList.push(res.result[i]);
            }
          }

          let returnCardList = [...activeCardList, ...errCardList];

          setCardList(returnCardList);
        } else {
          setCardList([]);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  useEffect(() => {
    NativeAction(phonecfg, "statusColor", "#FFFFFF");

    window.addEventListener("message", e => {
      if (e.data.messageId === "reload") {
        // 수신 후 처리
        setPageType("list");
        getMyCardList();
        setToastView({
          view: true,
          msgType: "cardAdd",
        });
      }
    });

    getMyCardList();
    setLoading(true);
  }, []);

  const [toastView, setToastView] = useState({
    view: false,
    msgType: "cardAdd",
  });

  useEffect(() => {
    toastView.view &&
      setTimeout(() => {
        // setToastView(false);
        setToastView({
          view: false,
          msgType: "cardAdd",
        });
      }, 5000);
  }, [toastView]);
  return (
    <Fragment>
      {loading && (pageType === "list" || pageType === 5) ? (
        <CardList
          setPageType={setPageType}
          setMoveUrl={setMoveUrl}
          cardList={cardList}
          getMyCardList={getMyCardList}
        />
      ) : (
        // <CardManagement setPageType={setPageType} pageType={pageType} />
        <ReceiptIframe setPageIdx={setPageType} moveUrl={moveUrl} />
      )}

      {toastView.view && (
        <div style={{ paddingLeft: "20px", willChange: "transform" }}>
          <ToastMsg
            option={{
              img: IC.check.ICON_GREEN_CHECK,
              // bottom: "102px",
              bottom: "24px",
              text: toastMsgObj[toastView.msgType].text,
            }}
          />
        </div>
      )}
    </Fragment>
  );
};

export default Card;
